import styled from 'styled-components';
import { Typography } from '../Typography';

export const PaddedBoldTypography = styled(Typography)`
    ${({ theme }) => `
        padding-right: ${theme.spacing(1)}px;
        && {
            font-weight: ${theme.typography.fontWeightBold};
        }
    `}
`;
